import React, { useEffect, useState }  from 'react';

const DropList = ({isOpen,setIsOpen,lorem}) => {
    const [openList, setOpenList] = useState(false)
    
    useEffect(() => {
        if (isOpen){
                setOpenList(true)
        } else setTimeout(() => {
                setOpenList(false)
                },500)
        
      },[isOpen])

    return (
        <>

                <div className={`notification_item_wrap_dropdown_content ${openList ? 'display-block' : ''}`}>
                    <div dangerouslySetInnerHTML={{ __html: lorem }}>
                        
                    </div>
                </div>
            
        </>
    );
};

export default DropList;